module.exports = __webpack_public_path__ + "img/2-4.b4e2b25c.svg";